<template>
    <div>
        <!-- The modal -->
        <b-modal @show="toggleParentScroll(false)" @hidden="toggleParentScroll(true)" id="modal-christmas"
            modal-class="custom-modal" content-class="popup" hide-header hide-footer>
            <div class="christmas-popup" :class="{ 'christmas-popup-ama': isAma }">
                <img class="ribbon" :src="baseImageUrl + '/popup/christmas/ribbon.png'" v-if="!isAma" />
                <div class="background"></div>
                <div class="header">
                    <span class="close-btn" @click="closeModal()"><font-awesome-icon :icon="['fa', 'times']" /></span>
                    <img v-if="!isAma" class="logo" :src="getLogoUrl()" />
                </div>

                <h3 class="title">
                    <span class="first">Merry</span>
                    <span class="second">Christmas</span>
                </h3>
                <p class="subtitle">{{ $t('popup.christmas.subtitle') }}</p>
                <button @click="goToShop();" class="btn shop-btn" v-if="!isAma">SHOP</button>
            </div>
        </b-modal>

        <b-modal @show="toggleParentScroll(false)" @hidden="toggleParentScroll(true)" id="modal-new-year"
            modal-class="custom-modal" content-class="popup" hide-header hide-footer>
            <div class="new-year-popup" :class="{ 'new-year-popup-ama': isAma }">
                <div class="background"></div>
                <div class="header">
                    <span class="close-btn" @click="closeModal()"><font-awesome-icon :icon="['fa', 'times']" /></span>
                    <img v-if="!isAma" class="logo" :src="getLogoUrl()" />
                </div>

                <h3 class="title">
                    <span class="first">Happy</span>
                    <span class="second">New Year</span>
                </h3>
                <p class="subtitle">{{ $t('popup.new_year.subtitle') }}</p>
                <div class="text-center">
                    <button @click="goToShop();" class="btn shop-btn" v-if="!isAma">SHOP</button>
                </div>
            </div>
        </b-modal>

        <b-modal @show="toggleParentScroll(false)" @hidden="toggleParentScroll(true)" id="modal-vicenzaoro"
            modal-class="custom-modal" content-class="popup" hide-header hide-footer no-close-on-backdrop>
            <div class="vicenzaoro-popup" :class="{ 'vicenzaoro-popup-ama': isAma }"><a target="_blank"
                    href="https://calendly.com/gioielleriaitaliana_marketing/vicenzaoro-gennaio-2024">
                    <div class="background"></div>
                    <div class="header">
                        <span class="close-btn" @click.prevent="closeModal()"><font-awesome-icon
                                :icon="['fa', 'times']" /></span>
                        <img v-if="!isAma" class="logo d-md-none" :src="getLogoUrl()" />
                    </div>
                    <div class="row text">
                        <div class="col-12 first-col" :class="{ 'col-md-6': !isAma }">
                            <span>{{ $t('popup.vicenzaoro.subtitle1') }} <b>Pad. 6, Stand 254</b></span>
                        </div>
                        <div class="col-12 second-col" :class="{ 'col-md-6': !isAma }">
                            <span>{{ $t('popup.vicenzaoro.subtitle2') }}</span>
                        </div>
                        <div class="col-12 book-here text-yellow">
                            {{ $t('popup.vicenzaoro.book_here') }}
                            <img class="click-icon" v-if="isAma"
                                src="https://content.gioielleriaitaliana.com/cr/popup/icons/click_AMA.png" />
                            <img class="click-icon" v-if="!isAma"
                                src="https://content.gioielleriaitaliana.com/cr/popup/icons/click_GI.png" />
                        </div>
                    </div>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "WelcomeModal",
    computed: {
        ...mapState({
            isAma: (state) => state.config.isAma,
        }),
        popupId: function () {
            var currentDate = new Date();
            var currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so adding 1

            /*if (currentMonth === 12 && currentDate.getDate() < 26) {
                return 'modal-christmas';
            } else if (currentMonth === 12 && currentDate.getDate() >= 26 || (currentMonth === 1 && currentDate.getDate() <= 1)) {
                return 'modal-new-year';
            } else if (currentMonth === 1 && currentDate.getDate() <= 23) {
                return 'modal-vicenzaoro';
            } else*/
                return '';
        }
    },
    data() {
        return {
            baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
        }
    },
    methods: {
        getLogoUrl: function () {
            return require('../assets/logo_GI_bianco.png');
        },
        closeModal: function () {
            this.$bvModal.hide(this.popupId)
        },
        goToShop: function () {
            this.closeModal();
            let productType = 'JEWELLERY'
            if (this.isAma)
                productType = 'AMA_JEWELLERY'
            this.$router.push({
                name: "list.sublist",
                params: {
                    productType: productType
                }
            });
        },
        toggleParentScroll(enableScroll) {

            if (enableScroll)
                window.parent.postMessage(
                    {
                        func: "setGioielleriaItalianaHeight",
                        message: document.body.scrollHeight,
                    },
                    "*"
                );
            else
                window.parent.postMessage(
                    {
                        func: "setGioielleriaItalianaHeight",
                        message: 'calc(100vh - 113px)',
                    },
                    "*"
                );
        },
    },
    mounted() {
        this.$bvModal.show(this.popupId)
        if (this.popupId == 'modal-christmas' || this.popupId == 'modal-new-year')
            setTimeout(() => {
                this.$bvModal.hide(this.popupId)
            }, 5000);
    },
}

</script>

<style lang="scss">
.custom-modal {
    padding-left: 0;

    .modal-dialog {
        display: flex;
        justify-content: center;
        max-width: 100%;
    }
}

.shop-btn {
    border: 1px solid black !important;
}

.popup {
    width: 600px !important;
    height: 400px !important;
    background-color: transparent !important;
    border: 0 !important;

    .modal-body {
        padding: 0 !important;
    }

    .shop-btn {
        padding: 5px 20px;
    }
}

.vicenzaoro-popup {
    background: url('https://content.gioielleriaitaliana.com/cr/popup/vicenzaoro/GIOIELLERIA_ITALIANA.png');
    background-color: var(--primary-color-1);
    min-height: 100%;

    &.vicenzaoro-popup-ama {
        background: url('https://content.gioielleriaitaliana.com/cr/popup/vicenzaoro/AMA.png');

        .header {
            .close-btn {
                color: black;
                right: 20px;
                display: block;
                position: absolute;
            }
        }

        .text {
            color: black !important;
            margin-top: 215px;
            width: 90%;
            padding: 0px 60px;

            .first-col {
                text-align: left;
                border-right: 0;
                padding-bottom: 5px;
                font-size: 13px;

                span {
                    display: block;
                    border-bottom: 1px solid black;
                    padding-bottom: 5px;
                }

            }

            .second-col {
                font-size: 13px;
            }

            .text-yellow {
                color: var(--ama-green);
            }
        }

        .book-here {
            text-align: left;
        }
    }

    a {
        text-decoration: none !important;
    }

    .book-here {
        font-size: 13px;
        text-decoration: underline;
        margin-top: 5px !important;
        text-transform: lowercase;
        text-align: center;
    }

    .click-icon {
        position: absolute;
        margin-left: -5px;
        margin-top: 3px;
    }

    .header {
        padding: 20px;

        .close-btn {
            color: white;

        }
    }

    .text {
        padding: 0px 30px;
        font-family: var(--font-family-reckless-italic);
        color: white;
        margin-top: 200px;

        .col-6 {
            padding: 0px 10px;
        }

        .first-col {
            text-align: right;
            border-right: 1px solid white;
        }

        .second-col {
            display: flex;
            flex-direction: column;
        }

        .text-yellow {
            color: #e4c778;
            margin-top: auto;
            margin-bottom: 0;
        }
    }
}


.new-year-popup {
    background: url('https://content.gioielleriaitaliana.com/cr/popup/new-year/GIOIELLERIA_ITALIANA.png');
    background-color: var(--primary-color-1);
    min-height: 100%;

    &.new-year-popup-ama {
        background: url('https://content.gioielleriaitaliana.com/cr/popup/new-year/AMA.png');

        .title {
            margin-top: 60px;
            text-align: left;
            margin-left: 50px;
            font-family: var(--font-family-general-sans);

            span {
                display: block;
                color: black !important;

                &.first {
                    color: var(--ama-green) !important;
                    font-size: 74px;
                    font-style: italic;
                }
            }
        }

        .subtitle {
            color: black;
            text-align: left;
            padding: 10px 60px;
        }

        .shop-btn {
            background-color: transparent;
        }

        .header {
            .close-btn {
                color: white;
                left: 15px;
            }
        }
    }

    .header {
        display: flex;
        justify-content: center;

        .close-btn {
            color: white;
            position: absolute;
            left: 25px;
            top: 20px;
            cursor: pointer;
        }

        .logo {
            height: 50px;
            margin-top: 20px;
        }
    }

    .title {
        text-align: center;
        font-family: var(--font-family-reckless-italic);
        font-size: 115px;
        line-height: 90px;

        span {
            display: block;
            color: white;

            &.second {
                color: #e4c778;
            }
        }
    }

    .subtitle {
        color: white;
        padding: 10px 80px;
        text-align: center;
        font-family: var(--font-family-reckless-italic);
    }

    .shop-btn {
        background-color: #e4c778;
    }
}

.christmas-popup {
    height: 100%;
    position: relative;

    &.christmas-popup-ama {
        .background {
            background: url('https://content.gioielleriaitaliana.com/cr/popup/christmas/AMA.png');
        }

        .subtitle {
            margin-left: 250px;
            margin-top: -10px;
            color: black;
            width: 280px;
            text-align: right;
        }

        .title {
            margin-left: 130px;
            margin-top: 0px;

            span {
                display: block;
                color: black;
                font-family: var(--font-family-general-sans);

                &.first {
                    margin-left: 50px;
                    margin-bottom: -30px;
                    font-style: italic;
                    color: var(--ama-green) !important;
                }

                &.second {
                    color: #B23434;
                }
            }
        }

        .shop-btn {
            margin-left: 240px;
            background-color: transparent;
            right: 70px;
            margin-top: 20px;
            position: absolute;

        }

        .header {

            .close-btn {
                color: black;
            }
        }
    }

    .background {
        background-color: var(--primary-color-1);
        z-index: -3;
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .ribbon {
        position: absolute;
        z-index: -1;
    }

    .header {
        display: flex;

        .close-btn {
            color: white;
            ;
            margin: 15px;
            cursor: pointer;
        }
    }

    .logo {
        height: 40px;
        margin: 15px;
        margin-left: auto;
    }

    .subtitle {
        font-family: var(--font-family-reckless-italic);
        color: white;
        margin-left: 155px;
    }

    .title {
        margin-bottom: 0;
        margin-top: 20px;
        font-size: 85px;
        font-family: var(--font-family-reckless-italic);
        color: white;
        margin-left: 155px;
        z-index: -2;
        position: relative;

        span {
            display: block;

            &.first {
                margin-left: 50px;
                margin-bottom: -30px;
            }

            &.second {
                color: #e4c778;
            }
        }

    }

    .shop-btn {
        background-color: #e4c778;
        padding: 2px 15px;
        margin-left: 155px;
        z-index: 20;
    }
}

@media only screen and (max-width: 768px) {
    .popup {
        width: 250px !important;
        height: 350px !important;
    }

    .ribbon {
        display: none;
    }

    .christmas-popup {
        .title {
            margin-left: 0 !important;
            font-size: 50px;

            span {
                &.first {
                    margin-left: 20px !important;
                    margin-bottom: -20px;
                }

                &.second {
                    margin-left: 20px !important;
                    margin-bottom: 20px;
                }
            }

        }

        .subtitle {
            color: white;
            margin-left: 020px;
        }

        .header {
            justify-content: space-between;

            .close-btn {
                margin: 20px;
                order: 2;
            }

            .logo {
                order: 1;
                margin-left: 20px;
            }
        }

        .shop-btn {
            margin-left: 20px;
            font-size: 13px;
        }

        &.christmas-popup-ama {
            .background {
                background: url('https://content.gioielleriaitaliana.com/cr/popup/christmas/mobile_AMA.png');
            }

            .title {
                margin-top: 0px !important;

                span {
                    &.first {
                        font-size: 48px;
                        margin-bottom: -20px;
                        margin-left: 40px !important;
                    }

                    &.second {
                        font-size: 43px;
                    }
                }
            }

            .subtitle {
                padding-left: 50px !important;
                padding-right: 20px !important;
                margin: 0;
                padding: 0;
                width: auto;
                font-size: 12px;
            }

            .shop-btn {
                position: absolute;
                right: 20px;
                font-size: 13px;
            }

            .header {
                justify-content: right;

                .close-btn {
                    color: black;
                    margin-top: 25px;
                }

            }
        }
    }

    .new-year-popup {
        background: url('https://content.gioielleriaitaliana.com/cr/popup/new-year/mobile_GIOIELLERIA_ITALIANA.png');
        background-color: var(--primary-color-1);

        .title {
            margin-left: 0 !important;
            font-size: 50px;
            line-height: normal;
            margin-top: 40px;

            span {
                &.first {
                    margin-bottom: -20px;
                }

                &.second {
                    margin-bottom: 0px;
                }
            }

        }

        .subtitle {
            color: white;
            padding: 15px;
            padding-top: 0;
            margin: 0cqw;
            font-size: 13px;
        }

        .header {
            justify-content: center;
            position: relative;

            .close-btn {
                left: 220px;
                top: 10px;
                position: absolute;
            }

            .logo {
                margin: 30px 0px 0px 0px;
                height: 40px;
            }
        }

        .shop-btn {
            padding: 2px 15px;
            font-size: 13px;
        }

        &.new-year-popup-ama {
            background: url('https://content.gioielleriaitaliana.com/cr/popup/new-year/mobile_AMA.png');
            background-color: white;

            .header {
                .close-btn {
                    margin-top: 8px;
                    color: black;
                }
            }

            .title {
                text-align: center;

                span {
                    &.first {
                        font-size: 41px;
                        margin-bottom: -10px;
                    }

                    &.second {
                        margin-bottom: 0px;
                        font-size: 83px;
                        line-height: 70px;
                    }
                }

            }

            .subtitle {
                text-align: center;
                font-size: 12px;
                padding: 5px 25px;
            }

            .shop-btn {
                background-color: transparent;
            }
        }
    }

    .vicenzaoro-popup {
        background: url('https://content.gioielleriaitaliana.com/cr/popup/vicenzaoro/mobile_GIOIELLERIA_ITALIANA.png');

        .header {
            text-align: center;
            position: relative;

            .close-btn {
                left: 220px;
                top: 10px;
                position: absolute;
                margin: 0;
                padding: 0;
            }

            .logo {
                margin: 10px 0px 0px 0px;
                height: 40px;
            }
        }

        .text {
            font-size: 11px;
            text-align: center;
            margin-top: 95px;

            .first-col {
                border: 0;
                border-bottom: 1px solid white;
                text-align: center;
                padding-bottom: 5px;
            }

            .second-col {
                padding-top: 5px;
            }
        }

        .book-here {
            font-size: 10px;
        }

        &.vicenzaoro-popup-ama {
            background: url('https://content.gioielleriaitaliana.com/cr/popup/vicenzaoro/mobile_AMA.png');

            .text {
                margin-top: 140px;
                width: 100%;
                padding: 0px 15px;
                font-size: 11px;
                margin-left: 0;

                .first-col {
                    border: 0;
                    font-size: 11px;
                }

                .second-col {
                    text-align: left;
                    font-size: 11px;
                    padding-top: 0;
                }
            }
        }
    }
}
</style>